import { UltimateOscillator as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = { ...defaultOptions };

  function calculator(data = []) {
    const { cycle1, cycle2, cycle3 } = options;

    const maxCycle = Math.max(cycle1, cycle2, cycle3);

    if (data.length < maxCycle + 1) {
      return [];
    }

    // Pre-calculate cycle products for weighting
    const c01 = cycle1 * cycle2;
    const c02 = cycle1 * cycle3;
    const c12 = cycle2 * cycle3;
    const denominator = c12 + c02 + c01;

    // Accumulate BP and TR for each cycle
    const accBP = [0, 0, 0]; // For cycle1, cycle2, cycle3
    const accTR = [0, 0, 0];
    const cycles = [cycle1, cycle2, cycle3];

    const results = [];

    for (let i = 0; i < data.length; i++) {
      if (i === 0) {
        results.push(undefined);
        continue;
      }

      const current = data[i];
      const prev = data[i - 1];

      // Check for required data
      if (
        current.close == null ||
        current.low == null ||
        current.high == null ||
        prev.close == null
      ) {
        results.push(undefined);
        continue;
      }

      // Calculate Buying Pressure and True Range
      const minLC = Math.min(current.low, prev.close);
      const bp = current.close - minLC;
      const tr = Math.max(current.high, prev.close) - minLC;

      // Update accumulators for each cycle
      for (let x = 0; x < cycles.length; x++) {
        accBP[x] += bp;
        accTR[x] += tr;

        // Remove oldest value if we exceed the cycle period
        if (i > cycles[x]) {
          const oldIdx = i - cycles[x];
          const oldCurrent = data[oldIdx];
          const oldPrev = data[oldIdx - 1];

          if (
            oldCurrent.close != null &&
            oldCurrent.low != null &&
            oldCurrent.high != null &&
            oldPrev.close != null
          ) {
            const oldMinLC = Math.min(oldCurrent.low, oldPrev.close);
            const oldBP = oldCurrent.close - oldMinLC;
            const oldTR = Math.max(oldCurrent.high, oldPrev.close) - oldMinLC;

            accBP[x] -= oldBP;
            accTR[x] -= oldTR;
          }
        }
      }

      // Calculate Ultimate Oscillator only after we have enough data
      if (i < maxCycle) {
        results.push(undefined);
        continue;
      }

      // Calculate weighted average
      // Avoid division by zero
      const avg1 = accTR[0] !== 0 ? accBP[0] / accTR[0] : 0;
      const avg2 = accTR[1] !== 0 ? accBP[1] / accTR[1] : 0;
      const avg3 = accTR[2] !== 0 ? accBP[2] / accTR[2] : 0;

      const numerator = c12 * avg1 + c02 * avg2 + c01 * avg3;
      const ultimateOsc =
        denominator !== 0 ? (100 * numerator) / denominator : undefined;

      results.push(ultimateOsc);
    }

    return results;
  }

  calculator.undefinedLength = function () {
    const { cycle1, cycle2, cycle3 } = options;
    return Math.max(cycle1, cycle2, cycle3);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return { ...options };
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
